import glamorous from "glamorous"
import style from "utils/style"

const ListItem = glamorous.li({
  color: style.colors.brown,
  lineHeight: 1.4,
  marginLeft: 30,
  paddingBottom: 17,
  "&:last-child": {
    paddingBottom: 0,
  },
})

export default ListItem



// WEBPACK FOOTER //
// ./src/elements/ListItem.js